import { render } from "./textbook-nav.vue?vue&type=template&id=60e766c4&scoped=true"
import script from "./textbook-nav.vue?vue&type=script&lang=js"
export * from "./textbook-nav.vue?vue&type=script&lang=js"

import "./textbook-nav.vue?vue&type=style&index=0&id=60e766c4&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e766c4"]])

export default __exports__